import d3 from '@/plugins/d3'

import { parties } from '@/config';
import ConfigMixin from './config';

const mixins = [ConfigMixin];

const methods = {
  resetMap() {
    this.isZoomed = false;
    this.drawMap();
  },
  resetZoom() {
    // this.active.classed('active', false);
    // this.active = d3.select(null);
    this.isZoomed = false;

    this.resetSelected();

    this.gLabels.selectAll('text').style('opacity', 1);
    this.gCities.selectAll('text').style('opacity', 1);
    this.gCities.selectAll('circle').style('opacity', 1);
    this.gOverlay.selectAll('path').style('opacity', 1);

    // this.gCities.selectAll('.city-label').style('font-size', '13px');

    this.svg
      .transition()
      .duration(750)
      .call(this.zoom.transform, d3.zoomIdentity);
  },
  updateHeight() {
    const map = d3.select(`#${this.id}`).node();
    let height = null;
    if (document.documentElement.clientWidth <= 400) {
      height = `${this.height.mobile}px`;
    } else {
      height = `${this.height.desktop}px`;
    }

    if (map) {
      map.setAttribute('style', `height: ${height}`);
    }
  },
  clearTooltip() {
    const el = document.getElementById(this.tooltipId);
    if (el) {
      el.remove();
    }
  },
  getTooltipHtml(d) {
    let result = this.getSelectedResults(d);
    if (!result) {
      this.tooltip.style('display', 'none');
      return;
    }

    const geoName = result.seat_name;
    const tableRows = parties.map(c => ({ ...c }))
      .sort((a, b) => {
        return result[`${b.match}_21_vote`] - result[`${a.match}_21_vote`]
      })
      .map(item => {
        const winning = item.match === result['2021_party'];
        const tag = winning ? 'b' : 'span';
        const style = winning ? ' style=color: black;' : '';
        const name = `<${tag}>${item.name}</${tag}>`;
        // const party = `<${tag}${style}>${candidate.Party.abbreviation}</${tag}>`;
        const votes = `<${tag}${style}>${parseFloat(result[`${item.match}_21_pct`] || 0).toFixed(1) || 0}</${tag}>`;

        const color = item.color;

        return `
          <tr class='candidates-table-row'>
            <td style='position: relative; padding: 0;'>
            <div
              style='position: absolute; top: 0; left: 0; height: 100%; width: 6px; background-color: ${color};'
            ></div>
            </td>
            <td class='tooltip-td' style='text-align: left; padding-left: 0px;'>${name}</td>
            <td class='tooltip-td' style='text-align: right;'>${votes}</td>
          </tr>
        `;
      })
      .join('');

    if (!tableRows) {
      this.tooltip.style('display', 'none');
      return;
    }

    let header = '';
    if (this.mobile) {
      header = `
        <div class='content-title'>
          <span style='font-size: 16.4px;'>${geoName}</span>
          <i class='tooltip-close material-icons' style='color: #333; font-size: 24px;'>close</i>
        </div>
      `;
    } else {
      header = `<div class='content-title'>${geoName}</div>`;
    }

    return `
      ${header}
      <table class='tooltip-topline-table' cellspacing='0'>
        <tr class='candidates-table-headers'>
          <th style='width: 10px;'></th>
          <th style='text-align: left; padding-left: 0;'>Party</th>
          <th style='text-align: right;'>Vote %</th>
        </tr>
      ${tableRows}
      </table>
    `;
  },
  getTooltip(d) {
    // if (window.self !== window.top) {
    //   return;
    // }
    const content = this.tooltip
      .append('div')
      .attr('class', 'map-tooltip-content');
    content.html(() => this.getTooltipHtml(d));
  },
  initializeToolTip() {
    this.tooltip = d3
      .select('body')
      .append('div')
      .attr('id', this.tooltipId)
      .append('div')
      .attr('id', this.tooltipContentId)
      .attr('class', 'results-map-tooltip')
      .on('click', () => {
        if (this.mobilePhone) {
          if (d3.event.target.className === 'tooltip-td') {
            event.stopPropagation();
          } else if (
            d3.event.target.className === 'tooltip-close material-icons'
          ) {
            this.resetSelected();
            this.tooltip.style('display', 'none');
          }
        }
      })
      .style('display', 'none');
  },
  getFillColor(d) {
    const result = this.getSelectedResults(d);
    if (result) {
      const winningParty = result['2021_party'];
      if (winningParty) {
        return this.getPartyColor(winningParty);
      }
    }
    return '#eeeeee';
  },
  resetSelected() {
    this.g
      .selectAll('path')
      .style('opacity', '1')
      .style('stroke', '#222')
      .style('stroke-width', 0.2);
  },
  highlightSelected(name, d3Obj) {
    const self = this;

    self.resetSelected();

    self.selected = null;
    self.selected = name;

    d3.select(d3Obj)
      .moveToFront()
      .style('stroke', '#222')
      .style('stroke-width', 0.2);

    self.g.selectAll('path').each(function(d) {
      let match = d;
      self.geoMatch.split('.').forEach(e => {
        match = match[e];
      });
      if (match !== name) {
        d3.select(this).style('opacity', '0.5');
      } else {
        d3.select(this).style('opacity', '1');
      }
    });
  }
};

export default {
  mixins,
  methods,
  data: () => ({
    tooltip: null,
    selected: null,
    svg: null,
    g: null,
    projection: null,
    gOverlay: null,
    gLabels: null,
    gCities: null,
    isZoomed: false,
    zoom: null,
    active: null
  })
};
